import { toggle } from "nodash"
import { EventAction, EventCategory } from "@nova/schemas"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { actionsFor } from "../activityFilters"
import { clearStagedCategory, selectStagedCategory, setStagedCategory } from "../slice"
import { FilterMenuShell, FilterOptionRow } from "./FilterMenuShell"
import { actionLabels, categoryLabels } from "./filterLabels"

export const CategoryFilterView = ({
    category,
    onBack,
    onCancel,
    onApply,
}: {
    category: EventCategory
    onBack: () => void
    onCancel: () => void
    onApply: () => void
}) => {
    const dispatch = useAppDispatch()
    const selection = useAppSelector(selectStagedCategory(category))
    const actions = actionsFor(category)

    const setActions = (nextActions: EventAction[]) => {
        if (!nextActions.length) {
            dispatch(clearStagedCategory(category))
            return
        }
        dispatch(setStagedCategory({ category, selection: { ...selection, actions: nextActions } }))
    }

    return (
        <FilterMenuShell
            title={categoryLabels[category]}
            onBack={onBack}
            onCancel={onCancel}
            onApply={onApply}
            onSelectAll={
                selection.actions.length === actions.length ? undefined : () => setActions(actions)
            }
            onClearAll={selection.actions.length > 0 ? () => setActions([]) : undefined}
        >
            {actions.map((action: EventAction) => (
                <FilterOptionRow
                    key={action}
                    label={actionLabels[action]}
                    selected={selection.actions.includes(action)}
                    onClick={() => setActions(toggle(selection.actions, action))}
                />
            ))}
        </FilterMenuShell>
    )
}
